import axios from 'axios'
import {AppConfig} from '../appConfig'
import {DocumentManager} from '@/DocumentManager'
import store from '../store'
import {METEG} from 'shared/js/commonHebrew'
import {processSpecialDisplayProps} from 'shared/js/processSpecialDisplayProps'
import Vue from 'vue'

const SIMPLE_SUCCESS = true
const NON_SUCCESS = false

function callWithAxiosAndReturnInfo(url, getOrPost, data) {
  var toReturn
  var args = [url]
  if (getOrPost.toLowerCase() === 'post') args.push(data)
  toReturn = axios[getOrPost.toLowerCase()](...args).then((response) => {
    if (response.status === 200) return response.data
    // eslint-disable-next-line no-console
    console.log('Response to ' + getOrPost.toUpperCase() + ' ' + url + ':')
    // eslint-disable-next-line no-console
    console.log(response)
    return null
  }).catch((error) => {
      // eslint-disable-next-line no-console
      console.log('Error trying to ' + getOrPost.toUpperCase() + ' ' + url + ': ' + error.message)
    return null
  })
  return toReturn
}

export const serverUpdateStatus = {
  text: ''
}
Vue.observable(serverUpdateStatus)

const trueResponses = [true, 'true', 'True']
const falseResponses = [false, 'false', 'False']

var _runningUrl = null
var _corpusIdOrJobID = null
function callRunningAndStatus() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(
        callWithAxiosAndReturnInfo(_runningUrl, 'get', null).then((runningInfo) => {
          if (!(trueResponses.concat(falseResponses).includes(runningInfo))) return NON_SUCCESS
          const statusUrl = AppConfig.SERVER_UPDATE.BASE_URL + '/status' + '/?corpusId=' + _corpusIdOrJobID
          return callWithAxiosAndReturnInfo(statusUrl, 'get', null).then((statusInfo) => {
            if (typeof statusInfo === 'string') Vue.set(serverUpdateStatus, 'text', statusInfo)
            if (trueResponses.includes(runningInfo)) return callRunningAndStatus()
            // eslint-disable-next-line no-console
            console.log('final status info:')
            // eslint-disable-next-line no-console
            console.log(statusInfo)
            return statusInfo
          })
        })
      )
    }, 1000)
  })
}

export default async function triggerServerUpdate(updateData = { fullrefresh: false }) { // return, resolved, is "success"
  if (!(AppConfig.SERVER_UPDATE.ALWAYS_TRIGGER)) return SIMPLE_SUCCESS
  const updateUrl = AppConfig.SERVER_UPDATE.BASE_URL + '/update'
  updateData['contentType'] = updateData.fullrefresh ? 'str' : AppConfig.SERVER_UPDATE.CONTENT_TYPE
  var corpusRoot
  const abbrevProjectSettings = store.state.dropbox?.projectSettings?.abbreviation
  if (!abbrevProjectSettings) {
    return {
      completionFailureInfo: [
        'עוד לא עשינו עדכון של הגדרות פיענוח לפרוייקט, כיוון שקובץ ההגדרות אינו קיים בתיקייה',
        'פנו אלינו בהקדם, כדי שנוכל לסדר זאת'
      ]
    }
  } else {
    updateData['metadata'] = abbrevProjectSettings
    corpusRoot = abbrevProjectSettings.corpusRoot
  }
  if (!(updateData.fullrefresh)) {
    const dropboxStatus = store.state.dropbox.status
    const pathDisplayParts = dropboxStatus.path_display.split('/')
    if (corpusRoot) {
      updateData['relpath'] = pathDisplayParts.slice(pathDisplayParts.indexOf(corpusRoot) + 1).join('/')
    } else updateData['fullFilePath'] = dropboxStatus.path_display
  } else updateData['relpath'] = ''
  if (updateData.relpath && updateData.relpath.includes('/')) updateData.relpath = './' + updateData.relpath
  if (updateData.fullrefresh) {
    updateData['content'] = ''
  } else if (AppConfig.SERVER_UPDATE.CONTENT_TYPE === 'str') { // simplified from NikudResultsContainer's localTokensObj
    var tokensArray = [] // but without removing metegs (& I'm not sure how current code works WITH removing them!)
    store.state.allWorkingNikud.wordsArray.forEach(wordObj => {
      if (wordObj.sepBefore) tokensArray.push({ text: wordObj.sepBefore })
      const postNikudShiftingArray = wordObj.standardLetterArray // nikudShifting not used here
      const postNikudShiftingString = postNikudShiftingArray.join('')
      const wordToken = {
        text: postNikudShiftingString,
        markedNonConfident: wordObj.specialData && wordObj.specialData.markedNonConfident
      }
      if (wordObj.wasAnAbbreviation && postNikudShiftingString.includes(METEG)) {
        wordToken.text = []
        let currentPart = { part: '', hideable: postNikudShiftingArray[0].includes(METEG) }
        postNikudShiftingArray.forEach(letter => {
          if (letter.includes(METEG) !== currentPart.hideable) {
            wordToken.text.push(currentPart)
            currentPart = { part: letter, hideable: letter.includes(METEG) }
          } else currentPart.part += letter
        })
        if (currentPart.part) wordToken.text.push(currentPart)
      }
      tokensArray.push(wordToken)
      if (wordObj.sepAfter) tokensArray.push({ text: wordObj.sepAfter })
    })
    const HSD = false // i.e. hideablesSuffixesDuplicated, ALWAYS false for the abbreviation expander
    const downloadWithAims = true // always, for update
    const nonConfidentMarking = true // always, for update
    const metegMode = 'keep-metegs' // always, for update
    updateData['content'] = processSpecialDisplayProps(tokensArray, downloadWithAims, HSD, nonConfidentMarking, metegMode)
  } else updateData['content'] = JSON.parse(DocumentManager.save())
  return callWithAxiosAndReturnInfo(updateUrl, 'post', JSON.stringify(updateData)).then((response) => {
    const validResponse = response === 'התחלנו!'
                          || (response && typeof response === 'object' && response.jobID)
    if (!validResponse) return NON_SUCCESS
    _corpusIdOrJobID = (typeof response === 'object')
                      ? response.jobID
                      : ((abbrevProjectSettings && abbrevProjectSettings.corpusId)
                         ? abbrevProjectSettings.corpusId
                         : AppConfig.SERVER_UPDATE.HARD_CODED_CORPUS_ID)
    _runningUrl = AppConfig.SERVER_UPDATE.BASE_URL + '/running' + '/?corpusId=' + _corpusIdOrJobID
    return callRunningAndStatus()
  })
}
